import { ReactElement, useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import AppHeader from './AppHeader';

const AppLayout = ({ children }: { children: ReactElement }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const hideHeader = queryParameters.get('hide-header');
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <UI_Wrapper>
      {!hideHeader && (
        <AppHeader
          onToggleMobileSidebar={() => setMobileSidebarOpen(!isMobileSidebarOpen)}
        />
      )}

      {/* Mobile overlay */}
      {isMobileSidebarOpen && (
        <UI_MobileOverlay onClick={() => setMobileSidebarOpen(false)} />
      )}

      <UI_BodyContainer $hideHeader={!!hideHeader}>
        <UI_Sidebar id="sidebar-wrapper">
          <Sidebar
            className={isMobileSidebarOpen ? 'mobile-open' : ''}
            onMobileClose={() => {
              setMobileSidebarOpen(false);
            }}
          />
        </UI_Sidebar>

        <UI_Content>
          {children}
        </UI_Content>
      </UI_BodyContainer>
    </UI_Wrapper>
  );
};

export default AppLayout;

const UI_Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  overflow: hidden;
`;

const UI_BodyContainer = styled.div<{ $hideHeader?: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: ${({ $hideHeader }) => ($hideHeader ? '100%' : 'calc(100% - var(--header-height))')};
  overflow: hidden;
`;

const UI_Sidebar = styled.div`
  height: 100%;
  position: relative;
  transition: width 0.3s ease;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 0;
    position: static;
  }
`;

const UI_Content = styled.div`
  flex: 1;
  height: 100%;
  position: relative;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100vw;
    margin-left: 0;
  }
`;

const UI_MobileOverlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(2px);
    z-index: 1500;
  }
`;
